import { render, staticRenderFns } from "./nuevoOficioEntrante.vue?vue&type=template&id=8bd07c30"
import script from "./nuevoOficioEntrante.vue?vue&type=script&lang=js"
export * from "./nuevoOficioEntrante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports